import React from "react"
import { H2 } from "../../../designSystem/typography/Heading"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { TextInput } from "../../../designSystem/inputs/TextInput";
import { Select } from "../../../designSystem/inputs/Select";
import { Button } from "../../../designSystem/button/Button";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { SelectField } from "../../../designSystem/formField/SelectField";
import { TextInputWithSave } from "../../../designSystem/inputs/TextInputWithSave";
import { TextSaveField } from '../../../designSystem/formField/text/TextSaveField';
import { TextArea } from "../../../designSystem/inputs/TextArea";
import { TextAreaWithSave } from "../../../designSystem/inputs/TextAreaWithSave";
import { TextAreaField } from "../../../designSystem/formField/textArea/TextAreaField";


export const FormComponentsOverview = (): JSX.Element => {

    return (
        <Flex flexDirection="column" gap={24}>
            <H2>Form components</H2>

            <Flex alignItems="flex-end">
                
                <Button
                    variant="filled"
                    text="filled"
                />


                <TextInput value="TextInput" onChange={() => { return; }} />

                <TextField
                    label="Label"
                    value="TextField"
                    onChange={() => { return; }}
                />

                <TextInputWithSave
                    value="TextInputWithSave"
                    onChange={() => { return; }}
                    onSave={() => { return; }}
                />

                <TextSaveField
                    label={"Vigtig felt!"}
                    value="TextSaveField"
                    onChange={() => { return; } }
                    onSave={() => { return; } }
                />

                <TextArea
                    value="TextArea"
                    onChange={() => { return; }}
                />


                <Select 
                    options={[
                        { value: '1', text: 'Select' },
                        { value: '2', text: 'Select' },
                        { value: '3', text: 'Select' }
                    ]} 
                    selectedValue={"Teks1"} 
                    onChange={() => { return; }}                
                />
                <SelectField
                    label="SelectField"
                    options={[
                        { value: '1', text: 'SelectField' },
                        { value: '2', text: 'SelectField' },
                        { value: '3', text: 'SelectField' }
                    ]}
                    selectedValue={"SelectField"}
                    onChange={() => { return; } }
                />
                <TextAreaWithSave
                    value="TextAreaWithSave"
                    onChange={() => { return; }}
                    onSave={() => { return; }}
                />

                <TextAreaField
                    label="Label"
                    value="TextAreaField"
                    onChange={() => { return; }}
                />
                <Button
                    variant="outlined"
                    text="outlined"
                />
            </Flex>



            <Flex gap={16}>
                
                <Button
                    variant="filled"
                    text="filled"
                    
                />


                <TextInput value="TextInput" onChange={() => { return; }} />

                <Select 
                    options={[
                        { value: '1', text: 'Select 1' },
                        { value: '2', text: 'Select 2' },
                        { value: '3', text: 'Select 3' }
                    ]} 
                    selectedValue={"2"} 
                    onChange={() => { return; }}                
                />
                

                <Button
                    variant="outlined"
                    text="outlined"
                />
            </Flex>






            <Flex gap={16}>
                <TextInput value="TextInput" onChange={() => { return; }} />
                <Button
                    variant="filled"
                    text="filled"
                />
            </Flex>



            <Flex gap={16} alignItems="flex-end">
                <TextField
                    label="Label"
                    value="TextField"
                    onChange={() => { return; }}
                />

                <TextInputWithSave
                    value="TextInputWithSave"
                    onChange={() => { return; }}
                    onSave={() => { return; }}
                />

                <TextSaveField
                    label={"Vigtig felt!"}
                    value="TextSaveField"
                    onChange={() => { return; } }
                    onSave={() => { return; } }
                />
            </Flex>


            <Flex gap={16} alignItems="flex-end">
                <TextArea
                    value="TextArea"
                    onChange={() => { return; }}
                />

                <Select 
                    options={[
                        { value: '1', text: 'Select Æble' },
                        { value: '2', text: 'Select Pære' },
                        { value: '3', text: 'Select Kokosnød' }
                    ]} 
                    selectedValue={"2"} 
                    onChange={() => { return; }}                
                />

            </Flex>



            <Flex gap={16}>
                <SelectField
                    label="SelectField"
                    options={[
                        { value: '1', text: 'SelectField' },
                        { value: '2', text: 'SelectField' },
                        { value: '3', text: 'SelectField' }
                    ]}
                    selectedValue={"SelectField"}
                    onChange={() => { return; } }
                />
                <TextAreaWithSave
                    value="TextAreaWithSave"
                    onChange={() => { return; }}
                    onSave={() => { return; }}
                />

            </Flex>


            <Flex gap={16} alignItems="flex-end">
                <TextAreaField
                    label="Label"
                    value="TextAreaField"
                    onChange={() => { return; }}
                />
                <Button
                    variant="outlined"
                    text="outlined"
                />

            </Flex>

        </Flex>
    );
}